import React, { useEffect, useState } from "react";

function ProtectedHome({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");

  const PASS = "MaterialsOfMatter";
  const EXP_DAYS = 4;

  useEffect(() => {
    const stored = localStorage.getItem("auth_expiry");
    if (stored && new Date(stored) > new Date()) {
      setAuthenticated(true);
    }
  }, []);

  const sendOtp = async () => {
    await fetch("/api/auth/send-otp", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ email, username }),
});

    setOtpSent(true);
  };

  const verifyOtp = async () => {
    const res = await fetch("/api/auth/verify-otp", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ email, otp }),
});

    const data = await res.json();
    if (data.verified) setEmailVerified(true);
    else alert("Invalid OTP");
  };

  const submitPassword = () => {
  if (password === PASS) {
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + EXP_DAYS);

    // 🔐 existing auth gate
    localStorage.setItem("auth_expiry", expiry.toISOString());

    // ✅ NEW: store user details in localStorage
    localStorage.setItem(
      "user_auth",
      JSON.stringify({
        username,
        email,
        loginTime: new Date().toISOString(),
        expiresAt: expiry.toISOString(),
      })
    );

    setAuthenticated(true);
  } else {
    alert("Wrong password");
  }
};


  if (!authenticated) {
    return (
      <div style={container}>
        <div style={card}>
          <input style={input} placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} />
          <input style={input} placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />

          {!otpSent && (
            <button style={button} onClick={sendOtp}>Verify Email</button>
          )}

          {otpSent && !emailVerified && (
            <>
              <input style={input} placeholder="Enter OTP" value={otp} onChange={e => setOtp(e.target.value)} />
              <button style={button} onClick={verifyOtp}>Confirm OTP</button>
            </>
          )}

          {emailVerified && (
            <>
              <input style={input} type="password" placeholder="Enter Password" value={password} onChange={e => setPassword(e.target.value)} />
              <button style={button} onClick={submitPassword}>Enter</button>
            </>
          )}
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

const container = {
  width: "100vw",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "16px",
};

const card = {
  width: "100%",
  maxWidth: "360px",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

const input = {
  padding: "12px",
  fontSize: "16px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const button = {
  padding: "12px",
  borderRadius: "6px",
  border: "none",
  backgroundColor: "black",
  color: "white",
  cursor: "pointer",
};

export default ProtectedHome;
